import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import {
 Grid,
 Paper,
  Box
} from "@material-ui/core";


export default function SkeletonComponent(props) {
    return (
      <div>
        <Box py={1}><Skeleton height={100} variant="rect" /></Box>
      <Box py={1}><Skeleton height={100} variant="rect" /></Box>
      <Box py={1}><Skeleton height={100} variant="rect" /></Box>
      <Box py={1}><Skeleton height={100} variant="rect" /></Box>
      {/* <Box py={1}>
      <Paper elevation={0}>
        <Box py={4} px={3}>
        
           
            <Box >

          <Grid container spacing={2} >
            <Grid item xs={12} sm={6} md={6} lg={4}><Skeleton height={35}  variant="rect" /></Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}><Skeleton height={35}  variant="rect" /></Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}><Skeleton height={35}  variant="rect" /></Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
          </Grid>
        </Box>
        </Box>
      </Paper>
      </Box>
      <Box py={1}>
      <Paper elevation={0}>
        <Box py={4} px={3}>
        
           
            <Box >

          <Grid container spacing={2} >
            <Grid item xs={12} sm={6} md={6} lg={4}><Skeleton height={35}  variant="rect" /></Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}><Skeleton height={35}  variant="rect" /></Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}><Skeleton height={35}  variant="rect" /></Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
            <Skeleton height={35} variant="rect" />
            </Grid>
          </Grid>
        </Box>
        </Box>
      </Paper>
      </Box> */}


    
      </div>
    );
  }